import { render, staticRenderFns } from "./Coreplate.vue?vue&type=template&id=5bdfea3a&scoped=true&"
import script from "./Coreplate.vue?vue&type=script&lang=js&"
export * from "./Coreplate.vue?vue&type=script&lang=js&"
import style0 from "./Coreplate.vue?vue&type=style&index=0&id=5bdfea3a&lang=scss&scoped=true&"
import style1 from "./Coreplate.vue?vue&type=style&index=1&id=5bdfea3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdfea3a",
  null
  
)

export default component.exports